"use client";

import { NavButton } from "@/components/nav-button";
import { useTrackEvent } from "@/components/events/tracking-event";
import type { IntegrationSource } from "@/lib/checkout/integration-sources";
import { getGtmIntegrationSourceProps } from "@/lib/tracking/gtm-integration-source";
import { ButtonProps } from "@/components/ui/button";
import { HTMLAttributeAnchorTarget, MouseEventHandler } from "react";

type ContinueBookingButtonProps = Omit<ButtonProps, "onClick"> & {
  href?: string | null;
  linkTarget?: HTMLAttributeAnchorTarget;
  trackContinueBooking?: boolean;
  integrationSource?: IntegrationSource;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

export function ContinueBookingButton({
  trackContinueBooking = false,
  integrationSource = "none",
  onClick,
  children,
  ...props
}: ContinueBookingButtonProps) {
  const trackEvent = useTrackEvent();

  return (
    <NavButton
      {...props}
      onLinkClick={(event) => {
        if (trackContinueBooking) {
          trackEvent("continue_booking_click", {
            cta_name: "continue_booking",
            ...getGtmIntegrationSourceProps(integrationSource),
          });
        }
        onClick?.(event);
      }}
    >
      {children}
    </NavButton>
  );
}
